export class AdminOrderProduct {
  public constructor(
    private readonly data: {
      name: string;
      quantity: number;
    },
  ) {}

  public get name(): string {
    return this.data.name;
  }

  public get quantity(): number {
    return this.data.quantity;
  }
}
